<div class="table__sort" (click)="onSort()">
  <i class="fa fa-sort"></i>
</div>